export default __webpack_public_path__ + "static/media/toyota1.3a82d62f.jpeg";